module.exports = __webpack_public_path__ + "static/media/logo.7b636497.svg";